import img1 from "./Team photos/Ananya.png";
import img2 from "./Team photos/priyanshu2.png";
import img3 from "./Team photos/krithika.png";
import img4 from "./Team photos/Renu.png";
import img5 from "./Team photos/Revanth.png";
import img6 from "./Team photos/Angelica.png";
import img7 from "./Team photos/jeswanth1.png";
import img8 from "./Team photos/Prathik.png";
import img9 from "./Team photos/Bindhu1.png";
import img10 from "./Team photos/Akhil.png";
import img11 from "./Team photos/Alekh.png";
import img12 from "./Team photos/Siddant.png";
import img13 from "./Team photos/Ajay.png";

const team=[
    {id: 1,name: "Ananya",role: "Licensee",image: img1,linkedin: "https://www.linkedin.com/in/kasukurthi-ananya-740639344/"},
    {id: 2,name: "Priyanshu",role: "Co-Licensee & Content Head",image: img2,linkedin: "https://www.linkedin.com/in/priyanshu-kumar-7a5801296/"},
    {id: 3,name: "Kritika",role: "Content Core",image: img3,linkedin: "https://www.linkedin.com/in/kritikashree/"},
    {id: 4,name: "Renu",role: "Content Core",image: img4,linkedin: "https://www.linkedin.com/in/madduluri-renu-sanjana-0a8869306/"},
    {id: 5,name: "Revanth",role: "Web Ops Head",image: img5,linkedin: "https://www.linkedin.com/in/revanth-reddy-tarimala-5621a7296/"},
    {id: 6,name: "Angelica",role: "Speakers Head",image: img6,linkedin: "https://www.linkedin.com/in/angelica-das-7aabb927a/"},
    {id: 7,name: "Jeshwanth",role: "Marketing Head",image: img7,linkedin: "https://www.linkedin.com/in/jeshwanth-sreeram-308b14282/"},
    {id: 8,name: "Pratik",role: "Marketing Core",image: img8,linkedin: "https://www.linkedin.com/in/pratikbhagat20/"},
    {id: 9,name: "Bindhu",role: "PR & Media Head",image: img9,linkedin: "https://www.linkedin.com/in/bindhu-pawar/"},
    {id: 10,name: "Akhil",role: "PR & Media Core",image: img10,linkedin: "https://www.linkedin.com/in/akhilravipati01/"},
    {id: 11,name: "Alekh",role: "Creatives Head",image: img11,linkedin: "https://www.linkedin.com/in/alekh-sethi-b1ba03285/"},
    {id: 12,name: "Siddhant",role: "Events Head",image: img12,linkedin: "https://www.linkedin.com/in/siddhant-kumawat/"},
    {id: 13,name: "Ajay",role: "Events Core",image: img13,linkedin: ""},
];

export default team;